const style = (theme) => {
  const output = {
    root: {
      minHeight: '100%',
      background: theme.colors[3],
      color: theme.colors[2],
    },
    wrapper: {
      extend: theme.wrapper,
      display: 'flex',
      paddingTop: 200,
    },
    hero: {
      color: theme.colors[1],
    },
    introText: {
      fontWeight: 300,
      fontSize: 50,
      lineHeight: 1.5,
    },
    grid: {
      display: 'flex',
      width: '100%',
    },
    gridHeading: {
      width: '45%',
      fontSize: 40,
      fontWeight: 300,
      textTransform: 'uppercase',
      lineHeight: 1,
    },
    gridContent: {
      flex: 1,
      fontSize: 20,
      lineHeight: 1.5,
      '& p': {
        marginBottom: 20,
      },
    },
    video: {
      width: '100%',
    },
  }

  /*------------------------------
  MD
  ------------------------------*/
  output[theme.mediaInverse.md] = {}

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {
    wrapper: {
      paddingTop: 100,
    },
    introText: {
      fontSize: 25,
      lineHeight: 1.2,
    },
    grid: {
      flexDirection: 'column',
      '& > *': {
        width: '100%',
        '&:not(:last-child)': {
          marginBottom: 40,
        },
      },
    },
  }

  return output
}

export default style
